import { render } from "./RelatorioUsinagensDashboard.vue?vue&type=template&id=e1d55f20&scoped=true"
import script from "./RelatorioUsinagensDashboard.vue?vue&type=script&lang=js"
export * from "./RelatorioUsinagensDashboard.vue?vue&type=script&lang=js"

import "./RelatorioUsinagensDashboard.vue?vue&type=style&index=0&id=e1d55f20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d55f20"]])

export default __exports__